import tracking from './tracking';
import { AccountField, CustomerSignUpField } from './forms';
import { TrackingEvent, TrackingEventSource } from './tracking/types';
import { PrivateRoutePath } from './routes';
import { buildQueryString } from './codecResultReporter';

import type { SignUpPayload } from '../components/SignUpForm/utils/form';
import type { BusinessRegistrationSource} from './tracking/types';

const fireTrack = (source: TrackingEventSource = TrackingEventSource.SIGN_UP, isTradie = false, isReferral = false) => {
  tracking.event(TrackingEvent.REGISTER, {
    source,
    is_referral: isReferral,
  });
  if (isTradie) tracking.event(TrackingEvent.REGISTER_AS_TRADE_BUSINESS, { source });
  if (isReferral) tracking.event(TrackingEvent.REFERRAL_REGISTER_TRADIE);
};

export const trackSignUp = (values: SignUpPayload, source: BusinessRegistrationSource) => {
  fireTrack(source, values[AccountField.BUYING_BEHALF] === 'business', !!values[CustomerSignUpField.REFERRAL_SLUG]);
};

export const trackTradeCustomerSignUp = () => {
  fireTrack(TrackingEventSource.TRADE_LANDING, true, false);
};

export const redirectSignUpOrSignIn = (isTradeCustomer: boolean, redirect: string) =>
  isTradeCustomer
    ? [PrivateRoutePath.TRADE_BUSINESS_WELCOME, buildQueryString({ uid: Date.now() })].join('?')
    : redirect;

export const trackSignUpQuote = (isTradie: boolean | undefined) => {
  fireTrack(TrackingEventSource.QUOTE, isTradie);
};
